import React from 'react';
import { Button } from 'mypages-library';
import { useTranslation } from 'react-i18next';
import PageTemplate from 'common/PageTemplate/PageTemplate';
import styles from 'common/PageTemplate/PageTemplate.module.scss';

export type ConfirmNewEmailErrorProps = {
  confirmNewEmail: () => void;
  supportPhoneNumber: string;
};

const ConfirmNewEmailError: React.FC<ConfirmNewEmailErrorProps> = ({ confirmNewEmail, supportPhoneNumber }) => {
  const { t } = useTranslation();
  return (
    <PageTemplate dataTestId="confirm-new-email-error-try-again">
      <h1 className={styles.title}>{t('MPL_CONFIRM_NEW_EMAIL_ERROR_TITLE')}</h1>
      <p className={styles.text}>{t('MPL_CONFIRM_NEW_EMAIL_ERROR_DESCRIPTION', { phone: supportPhoneNumber })}</p>
      <Button
        text={t('MPL_CONFIRM_NEW_EMAIL_ERROR_TRY_AGAIN_BTN')}
        className={styles.confirmButton}
        white
        onClick={confirmNewEmail}
        dataTestId="confrim-new-email-error-try-again-btn"
      />
    </PageTemplate>
  );
};

export default ConfirmNewEmailError;
